/* eslint-disable react-hooks/exhaustive-deps */

import * as Icon from 'base/ui/components/Icons';

import { Checkbox, Form, Radio, Spin, message } from 'antd';
import { useEffect, useMemo, useRef, useState } from 'react';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { commonMasterDataPresenter, commonMasterDataStore, vendorPresenter, vendorStore } from 'stores/root_store';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { validateEmail, validatePhone } from 'utils/validateHelper';

import BoxContainer from 'base/ui/components/BoxContainer';
import CustomBreadcrumb from 'base/ui/components/CustomBreadcrumb';
import CustomButton from 'base/ui/components/Button';
import CustomInput from 'base/ui/components/CustomInput';
import CustomSelect from 'base/ui/components/CustomSelect';
import { SYSTEM_TITLE } from 'utils/constants';
import { observer } from 'mobx-react';
import { removeEmptyValues } from 'utils/transformHelper';
import { useTranslation } from 'react-i18next';
import { ProColumns } from '@ant-design/pro-components';
import CustomProTable from 'base/ui/components/CustomTable';
import { Driver } from 'services/RawData/driver_services';
import { listSangChieu } from 'pages/rawData/Permission/model';

const createAddVendor = () => {
  return observer(() => {
    const { t } = useTranslation();

    // Get data params from url
    const { id: idParams } = useParams();

    // Check id để đặt tên trang
    let pageTitle = '';

    // Nếu có id là chỉnh sửa (xem chi tiết)
    if (idParams) {
      // Kiểm tra phân quyền
      // usePermission('INDEX'); // Kiểm tra xem được quyền truy cập vào trang
      pageTitle = t('page-title.update');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    } else {
      // Kiểm tra phân quyền
      // usePermission('CREATE');
      pageTitle = t('page-title.create');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    }
    const navigate = useNavigate();
    // Check button save and save continue

    const [form] = Form.useForm();
    const vendorTypeValue = Form.useWatch('vendorType', form);
    // Loading
    const [loading, setLoading] = useState(false);
    // Danh sách Tài xế
    const [listDriver, setListDriver] = useState<Driver[]>([]);
    const [saving, setSaving] = useState(false);
    const saveModeRef = useRef<'save' | 'save-continue'>('save');
    const [vendorTypeOptions, setVendorTypeOptions] = useState<{ label: string; value: string }[]>([]);

    const initialValues = useMemo(
      () => ({
        vendorType: undefined,
        actived: true,
        isAutoCreateAccount: false,
      }),
      [],
    );

    const detectVendorType = (value?: string, label?: string) => {
      const normalizedValue = (value || '').toLowerCase();
      const normalizedLabel = (label || '').toLowerCase();
      const isWaste =
        normalizedValue.includes('ct') ||
        normalizedLabel.includes('chất th') ||
        normalizedLabel.includes('waste') ||
        normalizedValue.includes('waste');
      const isMaterial =
        normalizedValue.includes('nvl') ||
        normalizedLabel.includes('nguyên vật') ||
        normalizedLabel.includes('material') ||
        normalizedValue.includes('material');
      return { isWaste, isMaterial };
    };

    const getVendorTypeLabel = (option: { label: string; value: string }) => {
      const detect = detectVendorType(option.value, option.label);
      if (detect.isWaste) {
        return t('masterdata.vendor.vendor-type-waste');
      }
      if (detect.isMaterial) {
        return t('masterdata.vendor.vendor-type-material');
      }
      return option.label;
    };

    const sortVendorOptions = (options: { label: string; value: string }[]) =>
      [...options].sort((a, b) => {
        const priority = (opt: { label: string; value: string }) => (detectVendorType(opt.value, opt.label).isWaste ? 0 : 1);
        return priority(a) - priority(b);
      });

    const isMaterialType = useMemo(() => {
      if (!vendorTypeValue) return false;
      const option = vendorTypeOptions.find((opt) => opt.value === vendorTypeValue);
      return detectVendorType(option?.value, option?.label).isMaterial;
    }, [vendorTypeValue, vendorTypeOptions]);
    //======================================================FUNCTION===============================================//
    // Call api detail store
    const getDetailVendor = async (employeeCode: string) => {
      setLoading(true);
      await vendorPresenter.getVendorDetail(vendorStore, employeeCode);
      if (vendorStore.vendorDetailResponse.isSuccess && vendorStore.vendorDetailResponse.data) {
        const detail = vendorStore.vendorDetailResponse.data;
        setListDriver(detail.drivers || []);
        form.setFieldsValue({
          supplierNumber: detail.supplierNumber,
          longName: detail.longName,
          email: detail.email,
          telephone: detail.telephone,
          address: detail.address,
          actived: detail.actived,
          periodTime: detail.periodTime,
          vendorType: (detail as any).vendorType || initialValues.vendorType,
          isAutoCreateAccount: (detail as any).isAutoCreateAccount ?? initialValues.isAutoCreateAccount,
          erpVendorCode: (detail as any).erpVendorCode ?? undefined,
        });
      } else {
        navigate('/MasterData/Vendor');
      }
      setLoading(false);
    };

    const handleSubmit = async (values: any) => {
      setSaving(true);
      const continueCreate = saveModeRef.current === 'save-continue';
      const payload = {
        ...values,
        vendorId: idParams,
      };
      removeEmptyValues(payload);

      if (idParams) {
        await vendorPresenter.updateVendor(vendorStore, { ...payload, vendorId: idParams });
      } else {
        await vendorPresenter.createVendor(vendorStore, payload);
      }

      if (vendorStore.crudResponse.isSuccess) {
        message.success(vendorStore.crudResponse.message || t('message.success'));
        if (continueCreate) {
          form.resetFields();
          const defaultVendorType = vendorTypeOptions[0]?.value;
          form.setFieldsValue({
            ...initialValues,
            vendorType: defaultVendorType,
          });
        } else {
          navigate('/MasterData/Vendor');
        }
      } else if (vendorStore.crudResponse.message) {
        message.error(vendorStore.crudResponse.message);
      }
      setSaving(false);
    };

    const defaultColumn: ProColumns<Driver>[] = [
      // Stt
      {
        title: t('masterdata.vendor.stt'),
        key: 'stt',
        width: 30,
        valueType: 'index',
        align: 'center',
        fixed: 'left',
      },
      // Mã tài xế
      {
        title: t('masterdata.vendor.driver-code'),
        dataIndex: 'driverCode',
        key: 'driverCode',
        width: 50,
        fixed: 'left',
        render: (_, record) => (
          <Link to={`/MasterData/Driver/${record.driverId}`}>{record.driverCode}</Link>
        )
      },
      // tên tài xế
      {
        title: t('masterdata.vendor.driver-name'),
        dataIndex: 'driverName',
        key: 'driverName',
        width: 200,
      },
      // Điện thoại
      {
        title: t('masterdata.vendor.phone'),
        dataIndex: 'phone',
        key: 'phone',
        width: 40,
        className: '!rounded-none !py-1',
        ellipsis: true,
      },
      // Email
      {
        title: t('masterdata.vendor.driver-license'),
        dataIndex: 'licenseNumber',
        key: 'licenseNumber',
        width: 80,
      },

    ];

    useEffect(() => {
      (async () => {
        await commonMasterDataPresenter.getCommonDataByKey(commonMasterDataStore, 'VendorType');
        const vendorTypes = commonMasterDataStore.commonRespone?.data || [];
        const mappedOptions = vendorTypes.map((item) => ({
          label: item.value,
          value: item.key,
        }));
        const sortedOptions = sortVendorOptions(mappedOptions);
        setVendorTypeOptions(sortedOptions);
        if (!idParams && sortedOptions.length && !form.getFieldValue('vendorType')) {
          form.setFieldsValue({ vendorType: sortedOptions[0].value });
        }

        if (idParams) {
          getDetailVendor(idParams);
        }
      })();
    }, [idParams]);

    const ButtonCreateUpdate = () => (
      <>
        <CustomButton
          icon={<Icon.Download className="!fill-[#262626]" />}
          disabled={saving}
          loading={saving && saveModeRef.current === 'save'}
          onClick={() => {
            saveModeRef.current = 'save';
            form.submit();
          }}
        >
          {t('btn.save')}
        </CustomButton>
        {/* lưu và tiếp tục */}
        <CustomButton
          type="primary"
          icon={<Icon.Download />}
          disabled={saving}
          loading={saving && saveModeRef.current === 'save-continue'}
          onClick={() => {
            saveModeRef.current = 'save-continue';
            form.submit();
          }}
        >
          {idParams ? t('btn.save-update') : t('btn.save-continue-create')}
        </CustomButton>
      </>
    );

    return (
      <>
        <div className="flex flex-col h-full">
          <CustomBreadcrumb
            pagetitle={[
              {
                title: t('masterdata.vendor.title'),
                link: '/MasterData/Vendor',
              },
              {
                title: pageTitle,
                link: idParams ? `/MasterData/Vendor/${idParams}` : '/MasterData/Vendor/create',
              },
            ]}
            extra={
              <div className="custom__mobile--save flex space-x-2">
                <ButtonCreateUpdate />
              </div>
            }
          />
          <BoxContainer fullHeight>
            <Spin spinning={loading}>
              <SearchForm
                column="col-2"
                form={form}
                initialValues={initialValues}
                onFinish={handleSubmit}
                className="gap-6"
              >
                <SearchItem
                  name="vendorType"
                  label={t('masterdata.vendor.vendor-type')}
                  rules={[{ required: true, message: t('masterdata.vendor.vendor-type-required') }]}
                >
                  <Radio.Group className="flex flex-row gap-6">
                    {vendorTypeOptions.map((type) => (
                      <Radio key={type.value} value={type.value}>
                        {getVendorTypeLabel(type)}
                      </Radio>
                    ))}
                  </Radio.Group>
                </SearchItem>
                {/* tự động tạo tài khoản */}
                <SearchItem
                  name="isAutoCreateAccount"
                  label={t('masterdata.vendor.auto-create-account-label')}
                  valuePropName="checked"
                  className={idParams ? 'hidden' : undefined}
                >
                  <Checkbox>{t('masterdata.vendor.auto-create-account')}</Checkbox>
                </SearchItem>

                <Form.Item noStyle shouldUpdate={(prev, curr) => prev.vendorType !== curr.vendorType}>
                  {({ getFieldValue }) => {
                    const currentType = getFieldValue('vendorType');
                    const option = vendorTypeOptions.find((opt) => opt.value === currentType);
                    const isMaterial = detectVendorType(option?.value, option?.label).isMaterial;
                    if (!isMaterial && !idParams) {
                      form.setFields([
                        { name: 'supplierNumber', value: undefined, errors: [] },
                      ]);
                    }
                    return (
                      <SearchItem
                        name="supplierNumber"
                        label={t('masterdata.vendor.vendor-code')}
                        rules={
                          isMaterial || idParams
                            ? [{ required: true, message: t('masterdata.vendor.vendor-code-required') }]
                            : undefined
                        }
                      >
                        <CustomInput
                          readOnly={idParams ? true : (!isMaterial && !idParams)}
                          disabled={idParams ? true : (!isMaterial && !idParams)}
                          className={idParams || (!isMaterial && !idParams) ? 'bg-gray-200 text-gray-500' : undefined}
                          placeholder={
                            isMaterial || idParams
                              ? t('masterdata.vendor.vendor-code-placeholder')
                              : t('masterdata.vendor.vendor-code-auto')
                          }
                        />
                      </SearchItem>
                    );
                  }}
                </Form.Item>
                <SearchItem name="erpVendorCode" label={t('masterdata.vendor.sap-code')}>
                  <CustomInput placeholder={t('masterdata.vendor.sap-code-placeholder')} />
                </SearchItem>
                <SearchItem
                  name="longName"
                  label={t('masterdata.vendor.full-name')}
                  rules={[{ required: true, message: 'Vui lòng nhập tên nhà cung cấp' }]}
                >
                  <CustomInput placeholder={t('masterdata.vendor.full-name-placeholder')} />
                </SearchItem>
                <SearchItem
                  name="periodTime"
                  label={t('masterdata.vendor.delivery-time')}
                >
                  <CustomSelect
                    options={listSangChieu}
                    placeholder={t('masterdata.vendor.delivery-time-placeholder')}
                    allowClear
                  />
                </SearchItem>
                <SearchItem
                  name="email"
                  label={t('masterdata.vendor.email')}
                  rules={[
                    { required: true, message: 'Vui lòng nhập email' },
                    { validator: validateEmail },
                  ]}
                >
                  <CustomInput placeholder={t('masterdata.vendor.email-placeholder')} />
                </SearchItem>

                <SearchItem
                  name="telephone"
                  label={t('masterdata.vendor.phone')}
                >
                  <CustomInput placeholder={t('masterdata.vendor.phone-placeholder')} />
                </SearchItem>
                <SearchItem
                  name="address"
                  label={t('masterdata.vendor.address')}
                >
                  <CustomInput placeholder={t('masterdata.vendor.address-placeholder')} />
                </SearchItem>
                <SearchItem
                  name="actived"
                  label={t('masterdata.vendor.status')}
                >
                  <Radio.Group className="flex gap-6">
                    <Radio value={true}>{t('radio-btn.active')}</Radio>
                    <Radio value={false}>{t('radio-btn.in-active')}</Radio>
                  </Radio.Group>
                </SearchItem>
              </SearchForm>
            </Spin>
            {idParams && (
              <CustomProTable<Driver>
                headerTitle={<h3 className="text-default font-bold">Danh sách tài xế đã học an toàn</h3>}
                loading={loading}
                columns={defaultColumn}
                rowKey="index"
                scroll={{ x: 'auto' }}
                dataSource={listDriver}
                pagination={false}
                options={false}
              />
            )}
          </BoxContainer>
        </div>
      </>
    );
  });
};

export default createAddVendor;
